/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./_SidebarGlobal";
import Paging from "./Paging";
import Auth from "../shared/Auth";
import FormInput from "./FormInput";
import { Modal } from "react-bootstrap";
import Icon from "./Icon";

class Quotes extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {
                page: props.params.page ?? 1,
                qfilters: {},
                search: null
            },
            filters: {},
            loaded: false,
            loading: false,
            list: [],
            req: {}
        };
        this.load = this.load.bind(this);
        this.onFilter = this.onFilter.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to="/quote/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Quote</L></span></Link>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.page !== this.props.params.page) {
            this.setState({ query: { ...this.state.query, page: this.props.params.page || 1 } });
        }
        if (prevState.query !== this.state.query) {
            if (this.state.query)
                this.load();
        }
    }

    dateFilter(filters, varNames, val) {
        var n = 0;
        if (val) {
            varNames.forEach(i => {
                filters[i] = val[n];
                n++;
            });
        }
        else {
            varNames.forEach(i => {
                delete filters[i];
            });
        }
    }

    onFilter(col) {
        var filters = { ...this.state.filters };

        if (col.filter.filter === 'quotedate') this.dateFilter(filters, ['InvoideStartDate', 'QuoteEndDate'], col.filter.value);
        else {
            if (col.filter.value)
                filters[col.filter.filter] = col.filter.value;
            else
                delete filters[col.filter.filter];
        }
        var query = { ...this.state.query, qfilters: filters };
        this.setState({ filters: filters, query: query });
    }

    load(query) {
        if (!query)
            query = this.state.query;
        this.setState({ loading: true });
        qreq.post('/api/quote/list', query, j => {
            if (j.list) {
                this.setState({ list: j.list, pageCount: j.pageCount, totalCount: j.totalCount });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    search = (v) => {
        let query = { ...this.state.query, search: v };
        this.setState({ query: query });
    }



    render() {
        const header = (<h1><L>Quote</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            { icon: 'Pencil', link: '/quote/edit/:id', tooltip: 'Edit Quote' },
            { icon: 'FilePdf', link: '/quote/edit/:id', tooltip: 'Download Quote', onClick: obj => { window.open(Globals.serverUrl + '/api/quote/report/pdf/' + obj.id + '/' + obj.qid + '.pdf'); } },
            {
                icon: 'PaperPlane', tooltip: 'Send Quote Signature Request', onClick: obj => this.setState({
                    showSendQuoteSignatureRequest: true,
                    req: {
                        quoteID: obj.id
                    },
                    selectedQuote: obj
                })
            },
            { name: 'qid', title: 'ID', link: '/quote/edit/:id', tooltip: 'Edit Quote', className: 'd-none d-md-table-cell' },
            { name: 'name', title: 'Title', link: '/quote/edit/:id' },
            { name: 'accountName', title: 'Account', className: 'd-none d-md-table-cell' },
            { name: 'quoteDate', title: 'Quote Date', link: '/quote/edit/:id', tooltip: 'Edit Quote', format: 'date', className: 'd-none d-md-table-cell' },
            {
                name: 'status', title: 'Status', valueFunc: row => {
                    if (row.isSigned)
                        return <span className="text-success">{row.status}</span>;
                    return row.status;
                }
            }
        ];


        columns.splice(1, 0, { icon: 'Trash', tooltip: 'Delete Quote', onClick: obj => { if (window.confirm('Are you sure you want to delete this quote?')) { qreq.post('/api/quote/delete', { id: obj.id }, () => { this.load(); }); } } });

        return <div className="container-fluid">
            {header}

            <SendSignRequest
                quote={this.state.selectedQuote}
                show={this.state.showSendQuoteSignatureRequest}
                onHide={() => this.setState({ showSendQuoteSignatureRequest: false })} />
            <div>
                <FormInput
                    model={this.state.query}
                    name="search"
                    type="text"
                    onChange={this.search}
                    label="Search..."
                    labelAsPlaceholder
                />
            </div>
            <DataTable columns={columns} data={this.state.list} loading={this.state.loading} totalCount={this.state.totalCount} showFilters={false} onFilter={this.onFilter} filters={[
                { name: 'quoteDate', title: 'Quote Date', filter: 'quotedate', type: 'daterange' }
            ]} />
            <div className="card-body">
                <Paging baseLoc="/quote/list/page/" pageCount={this.state.pageCount} currentPage={this.state.query?.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>
        </div>;
    }
}

// COM: SEND SIGN REQUEST

class SendSignRequest extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            req: {}
        };
    }

    send = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let info = { ...this.state.req };
            info.quoteID = this.props.quote.id;
            let j = await qreq.postAsync('/api/quote/request/send', info);
            if (j.item) {
                this.success('Email sent!');
                this.props.onHide();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    render() {
        return (
            this.props.show && <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header>
                    <Modal.Title><L>Signature Request</L></Modal.Title>
                </Modal.Header>
                <form onSubmit={this.send}>
                    <Modal.Body>
                        <FormInput model={this.state.req} name="name" label="Name" type="text" placeholder="John Doe" required disabled={this.state.submitting} />
                        <FormInput model={this.state.req} name="email" label="Email" type="email" placeholder="example@udhs.net" required disabled={this.state.submitting} />
                        <p className="text-muted"><L>Who are you sending this signature request to?</L></p>
                        <p><i><L>Signature request expires in 7 days if not processed.</L></i></p>
                        <p>The signature request is for quote: <strong>{this.props.quote?.name}</strong><br />Account: <strong>{this.props.quote?.accountName}</strong></p>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.submitting && <p>Submitting... Please wait...</p>}
                        {!this.state.submitting && <>
                            <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}><Icon icon="faPaperPlane" /> <L>Send</L></button>
                            <button type="button" className="btn btn-secondary btn-lg" onClick={this.props.onHide}><L>Cancel</L></button>
                        </>}
                    </Modal.Footer>
                </form>
            </Modal>
        );
    }
}

export default withParamsAndNavigate(Quotes);